import { Injectable } from '@angular/core';
import { Application, Category } from '@icullen/api/shared';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationUtilsService {
  constructor() {}

  transformApp(app: Application) {
    if (app) {
      if (app?.regulationApplication) {
        return { name: 'navigator', newApp: true, hasAccess: true };
      } else if (app.name.toLowerCase().startsWith('spectrum')) {
        return { name: 'spectrum', newApp: true, hasAccess: true };
      } else if (app.uniquenumber) {
        return { name: app.name, uniquenumber: app.uniquenumber, docApp: true };
      }
    }
    return app;
  }

  getAppNavUrl(app: Application) {
    if(app?.newApp && app.name === 'antitrust') {
      return '/site/case-database/COMPETITION_LAW_DOC';
    } else if (app?.newApp && app.name === 'stateaid') {
      return '/site/case-database/STATE_AID';
    } else if (app?.newApp && app.name === 'dmacase') {
      return '/client/site/dma-matrix';
    } else if (app?.newApp && app.name != 'antitrust' && app.name != 'stateaid' && app.name != 'dmacase') {
      return '/' + app.name + '/';
    } else if (app?.uniquenumber) {
      return '/client/site/documents/' + app.uniquenumber;
    } else {
      return '/product/applications/' + app?.name + '/intro.htm';
    }
  }

  // Categories BehaviorSubject
  private categoriesSubject = new BehaviorSubject<Category[]>([]);
  categories$: Observable<Category[]> = this.categoriesSubject.asObservable();
  setCategories(categories: Category[]): void {
    this.categoriesSubject.next(categories);
  }
  getCategories(): Category[] {
    return this.categoriesSubject.getValue();
  }
}
